<style lang="scss">
.home-page-template .ivu-carousel-dots-inside {
  left: 0
}
.shareModal .ivu-modal {
  top: 30px;
}
.shareModal .ivu-modal-footer {
  border-top: 0;
}
.shareModal .ivu-modal-header {
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
}
.shareModal .ivu-modal-body {
  overflow: visible !important;
}
.shareModal .ivu-modal-close {
  top: 4px;
}
.mCustomModaliOs .ivu-modal-footer {
  padding:15px;
  background: #fbfbfb;
}
.mCustomModaliOs .ivu-modal-header > p {
  overflow:inherit;
}
.mCustomModaliOs .ivu-modal-header{
  padding: 0px;
  border-bottom: 0px solid #ddd !important;
}
.mCustomModaliOs .ivu-modal-footer:after {
    /* content: ' '; */
    width: 20px;
    height: 20px;
    position:absolute;
    margin: 0 auto;
    left: 0;
    right: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 15px solid #fff;
    bottom: -20px;
  }
.mCustomModaliOs .ivu-modal{
  top: 30vh;
  position: absolute;
  left: 0;
  right: 0;
  width: 80vw !important;
  margin: 0 auto;
}

.ivu-carousel-item{
  height: 200px;
}

.ivu-carousel-dots-outside,
.ivu-carousel button.ivu-carousel-arrow {
    z-index: 1;
}

.demo-carousel {
  width: auto;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}

.card-feature{
  .ivu-card-body{
    padding: 0px !important;
  }
}
</style>
<style scoped>
  @media (max-width: 415px) {
    .snippet {
      -webkit-line-clamp: 2 !important;
    }
  }

  .snippet {
    -webkit-line-clamp: 2;
    display: block !important;
    display: -webkit-box !important;
    max-width: 400px !important;
    line-height: 16px !important;
    -webkit-box-orient: vertical !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    margin-right: 5px !important;
    font-size: 80% !important;
    padding: 0 !important;
  }

  .ms-carousel {
    width:100%;
    height: 270px;
    padding:0 15px;
  }
  .ms-carousel-item-div {
    width:92vw;
    display:inline-block;
  }
  .ms-carousel-item-div-card {
    position:relative;
    height:130px;
    overflow:hidden;
  }
  .ms-item-titlebar {
    position:absolute;
    top:0;
    left:0;
    color:white;
    padding:5px;
    width:100%;
    background: rgba(0,0,0,.3);
    text-align:left;
    z-index:1;
  }
  .ms-item-image-container {
    width:100%;
    background:#ddd;
    border-bottom:1px solid #ddd;
    overflow:hidden;
    height:215px;
  }
  .ms-item-image-container-invite{
    width:100%;
    background:#333;
    text-align:center;
    overflow:hidden;
    height:215px;
  }
  .card-holder {
    width: 100%;
    height: 130px;
    background: #fff;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: space-between;
  }
  .card-holder > .feed-details,.card-holder > .image{
    /* flex-grow: 1;
    flex-basis: 0; */
    height: 100%;
  }

  .card-holder > .feed-details{
    display: flex;
    flex-direction: column;
    width: 66%;
    padding: 10px;
  }

  .card-holder > .image{
    background-repeat: no-repeat !important;
    background-position: center !important;
    -webkit-background-size: cover !important;
    -moz-background-size: cover !important;
    -o-background-size: cover !important;
    background-size: cover !important;
    width:160px;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }
  .multiline-ellipsis {
      display: block !important;
      display: -webkit-box !important;
      max-width: 400px !important;
      /* min-height: 25px; */
      line-height: 16px !important;
      /* margin: 0 auto; */
      -webkit-line-clamp: 3 !important;
      -webkit-box-orient: vertical !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      margin-right: 5px !important;
      font-size: 80% !important;
      padding: 0 !important;
  }

  @media (min-width: 1281px) {
    .featured-feed-container {
      padding: 0px;
    }
  }
</style>

<template>
  <Row class="featured-feed" type="flex" v-if="true" justify="center" style="padding-bottom:10px">
    <Col :span="24" style="margin: 16px 0 5px;">
      <!-- <div style="position:relative; width: 100%; height: 40vh; overflow:hidden; overflow-x: auto; white-space: nowrap; "> -->
        <div class="featured-feed-container" style="padding: 0px; position: relative">
          <!-- <Carousel :radius-dot="true" dots="inside" class="ms-carousel" >
            <CarouselItem v-if="userInfo.user_type !== 'guest' && !userInfo.user_status">
              <div class="ms-carousel-item-div">
                <Card shadow :padding="0" class="ms-carousel-item-div-card">
                  <span class="ms-item-titlebar">
                    <Avatar style="color: white;background-color: red" icon="alert" size="small"></Avatar>&nbsp;<small><b>Confirm Email</b></small>
                  </span>
                  <div class="image-container ms-item-image-container-invite">
                    <img src="@/assets/confirm.png"
                        style="width:auto;background:#333;height:50%;margin-top:45px">
                  </div>
                  <div class="content" style="padding:0 8px">
                    <p align="left" class="truncate" style="line-height:15px;margin-top:8px">Please confirm your email address.</p>
                    <p align="left" class="truncate" style="line-height:15px;color:#aaa"><small><a @click="resendConfirmation()">Resend Confirmation</a></small></p>
                  </div>
                </Card>
              </div>
            </CarouselItem>
            <CarouselItem v-if="userInfo.user_type !== 'guest' && setViewHasPending">
              <router-link tag="div" to="/invitations" class="ms-carousel-item-div">
                <Card shadow :padding="0" class="ms-carousel-item-div-card">
                  <span class="ms-item-titlebar">
                    <Avatar style="color: white;background-color: red" icon="alert" size="small"></Avatar>&nbsp;<small><b>Invitation</b></small>
                  </span>
                  <div class="image-container ms-item-image-container-invite">
                    <img src="@/assets/invitation.png"
                        style="width:auto;background:#333;height:50%;margin-top:45px">
                  </div>
                  <div class="content" style="padding:0 8px">
                    <p align="left" class="truncate" style="line-height:15px;margin-top:8px">You have pending invitation.</p>
                    <p align="left" class="truncate" style="line-height:15px;color:#aaa"><small>Click here</small></p>
                  </div>
                </Card>
              </router-link>
            </CarouselItem>
            <CarouselItem v-for="(i,k) in featureActivity.data" v-if="featureActivity.data.length > 0" :key="k">
              <router-link tag="div" :to="'/feed/' + i.id" class="ms-carousel-item-div">
                <Card shadow :padding="0" class="ms-carousel-item-div-card" style="position:relative;border:1px solid #ddd" >
                  <div class="image-container ms-item-image-container" style="position:relative">
                    <span style="line-height:200px;position:absolute;width:50px;left:40vw;right:0;height:100%;">
                      <Avatar class="play-icon" v-if="i.type == 'attachment' && i.data.attachment_type == 'video'" icon="play" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                      <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'slideshow'" icon="images" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                      <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'link'" icon="link" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                    </span>
                    <img :src="i.cover_photo[0].medium"
                        style="    width: auto;display: block;margin: 0 auto;height:100%">
                  </div>
                  <div class="content" style="padding:0 8px">
                    <p align="left" class="truncate" style="line-height:15px;margin-top:8px">{{i.title}}</p>
                    <p align="left" class="truncate" style="line-height:15px;color:#aaa"><small>{{snippet(i)}}</small></p>
                  </div>
                </Card>
              </router-link>
            </CarouselItem>
          </Carousel> -->
          <Card class="card-feature" shadow :span="24" style="margin: auto; background: #fff;width:330px; height: 130px;padding: 0px;" 
            v-if="featureActivity.data.length == 0 && isFeatureLoading">
            <VueContentLoading :width="330" :height="130" style="height: 100%" :speed="featureActivity.data.length == 0 ? 9999 : 0">
              <rect x="10" y="12" rx="4" ry="4" width="170" height="16" />
              <rect x="10" y="37" rx="4" ry="4" width="100" height="10" />
              <rect x="190" y="2" rx="4" ry="4" width="137" height="126" />
            </VueContentLoading>
          </Card>

          <swiper v-show="presentation=='slideshow'" :options="swiperOption" class="presentation">
            <swiper-slide v-if="false && userInfo.user_type !== 'guest' && !userInfo.user_status">
              <div class="demo-carousel">
                <div class="ms-carousel-item-div">
                  <!-- <Card shadow :padding="0" class="ms-carousel-item-div-card">
                    <span class="ms-item-titlebar">
                      <Avatar style="color: white;background-color: red" icon="alert" size="small"></Avatar>&nbsp;<small><b>Confirm Email</b></small>
                    </span>
                    <div class="image-container ms-item-image-container-invite">
                      <img src="@/assets/confirm.png"
                          style="width:auto;background:#333;height:50%;margin-top:45px">
                    </div>
                    <div class="content" style="padding:0 8px">
                      <p align="left" class="truncate" style="line-height:15px;margin-top:8px">Please confirm your email address.</p>
                      <p align="left" class="truncate" style="line-height:15px;color:#aaa"><small><a @click="resendConfirmation()">Resend Confirmation</a></small></p>
                    </div>
                  </Card> -->

                  <Card shadow :padding="0" class="ms-carousel-item-div-card">
                    <div class="card-holder">
                      <div class="feed-details" style="position: relative">
                        <div class="header" style="margin-bottom: 5px;">
                          <Avatar style="color: white;background-color: red" icon="alert" size="small"></Avatar>&nbsp;<small><b>Confirm Email</b></small>
                        </div>
                        <div class="feed-actions" style="position: absolute;bottom: 20px;">
                          <p>Please confirm your email address.</p>
                          <small><a @click="resendConfirmation()">Resend Confirmation</a></small>
                        </div>
                      </div>
                      <div class="image" style="padding: 10px;">
                        <img alt=" " :src="confirmEmail" style="width: 100%">
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide v-if="userInfo.user_type !== 'guest' && setViewHasPending && false">
              <div class="demo-carousel">
                <div class="ms-carousel-item-div">
                  <!-- <Card shadow :padding="0" class="ms-carousel-item-div-card">
                    <span class="ms-item-titlebar">
                      <Avatar style="color: white;background-color: red" icon="alert" size="small"></Avatar>&nbsp;<small><b>Invitation</b></small>
                    </span>
                    <div class="image-container ms-item-image-container-invite">
                      <img src="@/assets/invitation.png"
                          style="width:auto;background:#333;height:50%;margin-top:45px">
                    </div>
                    <div class="content" style="padding:0 8px">
                      <p align="left" class="truncate" style="line-height:15px;margin-top:8px">You have pending invitation.</p>
                      <p align="left" class="truncate" style="line-height:15px;color:#aaa"><small>Click here</small></p>
                    </div>
                  </Card> -->

                  <Card shadow :padding="0" class="ms-carousel-item-div-card">
                    <div class="card-holder">
                      <div class="feed-details" style="position: relative">
                        <div class="header" style="margin-bottom: 5px;">
                          <Avatar style="color: white;background-color: red" icon="alert" size="small"></Avatar>&nbsp;<small><b>Invitation</b></small>
                        </div>
                        <div class="feed-actions" style="position: absolute;bottom: 20px;">
                          <p>You have pending invitation.</p>
                          <router-link tag="a" to="/invitations"><small>Click here</small></router-link>
                        </div>
                      </div>
                      <div class="image" style="padding: 10px;">
                        <img alt=" " :src="invitation" style="width: 100%">
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide v-for="(i,k) in featureActivity.data" v-show="featureActivity.data.length > 0" :key="k">
              <div class="demo-carousel pointer" style="position:relative" @click="$store.dispatch('statistics/postStats', {stat_type: 'activity_link', stat_id: i.id, link_tag: 'View Activity'})">
                <router-link tag="div" style="width:100%" :to="'/feed/' + i.id" class="ms-carousel-item-div">
                  <!-- <Card shadow :padding="0" class="ms-carousel-item-div-card" style="position:relative;border:1px solid #ddd" >
                    <div class="image-container ms-item-image-container" style="position:relative">
                      <span style="line-height: 200px;position: absolute;width: 50px;left: 40vw;right: 0px;height: 100%;margin: auto;position: absolute;top: 0;left: 0;bottom: 0;right: 0;">
                        <Avatar class="play-icon" v-if="i.type == 'attachment' && i.data.attachment_type == 'video'" icon="play" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                        <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'slideshow'" icon="images" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                        <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'link'" icon="link" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                      </span>
                      <img :src="i.cover_photo[0].medium"
                          style="    width: auto;display: block;margin: 0 auto;height:100%">
                    </div>
                    <div class="content" style="padding:0 8px">
                      <p align="left" class="truncate" style="line-height:15px;margin-top:8px">{{i.title}}</p>
                      <p align="left" class="truncate" style="line-height:15px;color:#aaa"><small>{{snippet(i)}}</small></p>
                    </div>
                  </Card> -->
                  <Card shadow :padding="0" class="ms-carousel-item-div-card" style="position:relative;border:1px solid #ddd">
                    <div class="card-holder">
                      <div class="feed-details">
                        <div style="height: 70%;">
                          <small style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;line-height:20px"><b>{{getTextFromHTML(i.title)}}</b></small>
                          <!-- <small><Ellipsis
                            :assume-pixel="2"
                            :expandables="false"
                            :content="featuredDescription(i)">
                          </Ellipsis></small> -->
                          <small class="snippet">{{getTextFromHTML(snippet(i))}}</small>
                          <!-- <read-more style="font-size:9px !important;margin-top:10px;"
                            more-str="."
                            :text="(i.data.tip==undefined) ? '':i.data.tip"
                            less-str="."
                            :max-chars="180">
                          </read-more> -->
                        </div>
                        <div v-show="i.activity_count" class="feed-actions" style="height: 30%; font-size:77% !important; display: flex; align-items: flex-end;">
                          <router-link style="font-size: 80%;color:rgb(170, 170, 170);" tag="span" :to="'/feed/' + i.id"><i class="far fa-comment"></i>&nbsp;
                            Comments {{ (i.activity_count > 0) ? i.activity_count : ''}}</router-link>
                        </div>
                      </div>
                      <div class="image" :style="{background: 'url('+ postPreviewImage(i) +')'}" v-if="i.cover_photo">
                        <span class="feed-icons">
                          <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'video'" icon="play" class="feed-icon"></Avatar>
                          <!-- <Avatar v-if="i.type == 'trivia' && i.data.mode == 'poll'" icon="pie-graph" class="feed-icon"></Avatar> -->
                          <Avatar v-if="i.type == 'trivia' && i.data.mode == 'poll'" :src="barIcon" class="feed-icon"></Avatar>
                          <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'slideshow'" icon="images" class="feed-icon"></Avatar>
                          <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'link'" icon="link" class="feed-icon"></Avatar>
                        </span>
                      </div>
                    </div>
                  </Card>
                </router-link>
              </div>
            </swiper-slide>
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            <div class="swiper-pagination" v-show="featureActivity.data.length > 0" slot="pagination" style="position:initial !important;" ></div>
          </swiper>
          <Carousel v-show="presentation=='carousel'" :radius-dot="true" :dots="featureActivity.data.length > 1 ? 'outside' : 'none'" loop :arrow="showArrow">
            <CarouselItem v-if="false && userInfo.user_type !== 'guest' && !userInfo.user_status">
                <div class="demo-carousel">
                  <div class="ms-carousel-item-div">
                    <!-- <Card shadow :padding="0" class="ms-carousel-item-div-card">
                      <span class="ms-item-titlebar">
                        <Avatar style="color: white;background-color: red" icon="alert" size="small"></Avatar>&nbsp;<small><b>Confirm Email</b></small>
                      </span>
                      <div class="image-container ms-item-image-container-invite">
                        <img src="@/assets/confirm.png"
                            style="width:auto;background:#333;height:50%;margin-top:45px">
                      </div>
                      <div class="content" style="padding:0 8px">
                        <p align="left" class="truncate" style="line-height:15px;margin-top:8px">Please confirm your email address.</p>
                        <p align="left" class="truncate" style="line-height:15px;color:#aaa"><small><a @click="resendConfirmation()">Resend Confirmation</a></small></p>
                      </div>
                    </Card> -->

                    <Card shadow :padding="0" class="ms-carousel-item-div-card">
                      <div class="card-holder">
                        <div class="feed-details" style="position: relative">
                          <div class="header" style="margin-bottom: 5px;">
                            <Avatar style="color: white;background-color: red" icon="alert" size="small"></Avatar>&nbsp;<small><b>Confirm Email</b></small>
                          </div>
                          <div class="feed-actions" style="position: absolute;bottom: 20px;">
                            <p>Please confirm your email address.</p>
                            <small><a @click="resendConfirmation()">Resend Confirmation</a></small>
                          </div>
                        </div>
                        <div class="image" style="padding: 10px;">
                          <img alt=" " :src="confirmEmail" style="width: 100%">
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
            </CarouselItem>
            <CarouselItem v-if="userInfo.user_type !== 'guest' && setViewHasPending">
                <div class="demo-carousel">
                  <div class="ms-carousel-item-div">
                    <!-- <Card shadow :padding="0" class="ms-carousel-item-div-card">
                      <span class="ms-item-titlebar">
                        <Avatar style="color: white;background-color: red" icon="alert" size="small"></Avatar>&nbsp;<small><b>Invitation</b></small>
                      </span>
                      <div class="image-container ms-item-image-container-invite">
                        <img src="@/assets/invitation.png"
                            style="width:auto;background:#333;height:50%;margin-top:45px">
                      </div>
                      <div class="content" style="padding:0 8px">
                        <p align="left" class="truncate" style="line-height:15px;margin-top:8px">You have pending invitation.</p>
                        <p align="left" class="truncate" style="line-height:15px;color:#aaa"><small>Click here</small></p>
                      </div>
                    </Card> -->

                    <Card shadow :padding="0" class="ms-carousel-item-div-card">
                      <div class="card-holder">
                        <div class="feed-details" style="position: relative">
                          <div class="header" style="margin-bottom: 5px;">
                            <Avatar style="color: white;background-color: red" icon="alert" size="small"></Avatar>&nbsp;<small><b>Invitation</b></small>
                          </div>
                          <div class="feed-actions" style="position: absolute;bottom: 20px;">
                            <p>You have pending invitation.</p>
                            <router-link tag="a" to="/invitations"><small>Click here</small></router-link>
                          </div>
                        </div>
                        <div class="image" style="padding: 10px;">
                          <img alt=" " :src="invitation" style="width: 100%">
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
            </CarouselItem>
            <CarouselItem v-for="(i,k) in featureActivity.data" v-if="featureActivity.data.length > 0" :key="k">
                <div class="demo-carousel" @click="">
                  <router-link tag="div" :to="'/feed/' + i.id" class="ms-carousel-item-div">
                    <!-- <Card shadow :padding="0" class="ms-carousel-item-div-card" style="position:relative;border:1px solid #ddd" >
                      <div class="image-container ms-item-image-container" style="position:relative">
                        <span style="line-height: 200px;position: absolute;width: 50px;left: 40vw;right: 0px;height: 100%;margin: auto;position: absolute;top: 0;left: 0;bottom: 0;right: 0;">
                          <Avatar class="play-icon" v-if="i.type == 'attachment' && i.data.attachment_type == 'video'" icon="play" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                          <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'slideshow'" icon="images" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                          <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'link'" icon="link" style="width:50px;height:50px;border-radius:100%;line-height:50px;background:rgba(255,255,255,.9);color:#333;border:1px solid #333;font-size:30px"></Avatar>
                        </span>
                        <img :src="i.cover_photo[0].medium"
                            style="    width: auto;display: block;margin: 0 auto;height:100%">
                      </div>
                      <div class="content" style="padding:0 8px">
                        <p align="left" class="truncate" style="line-height:15px;margin-top:8px">{{i.title}}</p>
                        <p align="left" class="truncate" style="line-height:15px;color:#aaa"><small>{{snippet(i)}}</small></p>
                      </div>
                    </Card> -->

                    <Card shadow :padding="0" class="ms-carousel-item-div-card" style="position:relative;border:1px solid #ddd">
                      <div class="card-holder">
                        <div class="feed-details">
                          <small><b style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;">{{i.title}}</b></small>
                          <div class="feed-actions" style="position: absolute;bottom: 5px;">
                            <router-link style="font-size: 80%;color:rgb(170, 170, 170);" tag="span" :to="'/feed/' + i.id"><i class="far fa-comment"></i>&nbsp;
                              Comments {{ (i.activity_count > 0) ? i.activity_count : ''}}</router-link>
                          </div>
                        </div>
                        <div class="image" :style="{background: 'url('+ postPreviewImage(i) +')'}" v-if="i.cover_photo">
                          <span class="feed-icons">
                            <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'video'" icon="play" class="feed-icon"></Avatar>
                            <!-- <Avatar v-if="i.type == 'trivia' && i.data.mode == 'poll'" icon="pie-graph" class="feed-icon"></Avatar> -->
                            <Avatar v-if="i.type == 'trivia' && i.data.mode == 'poll'" :src="barIcon" class="feed-icon"></Avatar>
                            <!-- <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'slideshow'" icon="images" class="feed-icon"></Avatar> -->
                            <Avatar v-if="i.type == 'attachment' && i.data.attachment_type == 'link'" icon="link" class="feed-icon"></Avatar>
                          </span>
                        </div>
                      </div>
                    </Card>
                  </router-link>
                </div>
            </CarouselItem>
          </Carousel>

          <Card shadow :padding="0" v-if="featureActivity.data.lenght < 0">
            <div class="no-featured-content" style="display: flex;align-items: center;align-content: center;justify-content: center;background: #fff;height: 130px;">
              <img alt=" " :src="tmLogo" style="height:100%; width: auto"/>
            </div>
          </Card>

          <!-- <div v-for="i in 3" :key="i" style="width:51.5vh;display:inline-block;margin-right:16px">
            <Card shadow :padding="0" style="position:relative;height:40vh;overflow:hidden">
              <span style="position:absolute;top:0;left:0;color:white;padding:5px;width:100%;background: rgba(0,0,0,.1);text-align:left">
                <Avatar icon="person" size="small"></Avatar>&nbsp;<small>Sharpen Warrior</small>
              </span>
              <div class="image-container" style="overflow:hidden;height:33vh">
                <img src="https://sa.kapamilya.com/absnews/abscbnnews/media/news-special1/nation/11/11/duterte-malaysia-rtr.jpg"
                     style="width:100%;background:#333">
              </div>
              <div class="content" style="padding:0 8px">
                <p align="left" class="truncate" style="line-height:15px;margin-top:8px">Lotem ipsum dolor ismet, lorem ipsum dolor ismet. Lotem ipsum dolor ismet</p>
                <p align="left" class="truncate" style="line-height:15px;color:#aaa"><small>Lotem ipsum dolor ismet, lorem ipsum dolor ismet. Lotem ipsum dolor ismet</small></p>
              </div>
            </Card>
          </div> -->
        </div>
        <!-- <div style="width:100%;height: 30vh;white-space: nowrap;padding-left:20%"> -->
        <!-- <div style="width:100%;height: 30vh;white-space: nowrap;text-align: center;">
          <div v-if="featureActivity.data.length > 0" style="width:250px;padding:0 0px 5px 0px;height:100%;margin:0 auto;display:inline-block">
            <Card :padding="0" style="position:relative">
              <router-link tag="div" :to="'/feed/' + featureActivity.data[0].id">
                <div style="width:100%;height:165px;overflow:hidden">
                  <img width="100%" height="auto" :src="featureActivity.data[0].cover_photo[0].medium" />
                </div>
                <div style="text-align:left;padding:5px 15px 10px;position:relative;overflow:hidden">
                  <p style="line-height;width:100%;white-space: normal;"><b>{{featureActivity.data[0].title}}</b></p>
                  <small><timeago :since="featureActivity.data[0].rrule_parsed_date"></timeago></small>
                </div>
              </router-link>
            </Card>
          </div>
          <div v-else style="width:250px;padding:0 0px 5px 0px;height:100%;margin:0 auto;display:inline-block">
            <Card :padding="0" style="position:relative">
              <img width="100%" src="https://sa.kapamilya.com/absnews/abscbnnews/media/news-special1/nation/11/11/duterte-malaysia-rtr.jpg" />
              <div style="text-align:left;padding:5px 15px 10px;position:relative;overflow:hidden">
                <p><b>Partners For Change</b></p>
                <p>Welcome</p>
              </div>
            </Card>
          </diV> -->
        <!-- </div> -->
      </div>
    </Col>
    <!-- <Col :span="24" :style="{textAlign: 'center',padding: '10px 0 0'}" v-if="userInfo.user_type !== 'guest' && !userInfo.user_status">
      <Alert type="warning"><b>Please confirm your email address,<br/> or (<a @click="resendConfirmation()">Resend Confirmation</a>)</b></Alert>
    </Col>
    <Col :span="24" :style="{textAlign: 'center',padding: '10px 0 0'}" v-if="userInfo.user_type !== 'guest' && setViewHasPending">
      <router-link to="/invitations">
        <Alert><b>You have pending invitation (<a>View</a>)</b></Alert>
      </router-link>
    </Col> -->
    <!-- $store.state.base.showInstructionCard -->
    <Button v-if="checkIsMobile" @click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: 'Install App'});redirectUrl" :disabled="getIsFetchingUrlLoader" style="padding: 10px 50px; margin: 5px 0;" size="large" type="error"><i class="far fa-arrow-alt-circle-down"></i> Install App</Button>
    <!-- <Col :span="24" v-if="$store.state.base.showInstructionCard && ishideONIOSos" style="text-align:center">
      <Card :padding="10" style="width:50%;margin:5px auto;position:relative;background:rgb(248, 19, 0);color:white">
        <div align="center" @click="showInstruction = true">
         <i class="far fa-arrow-alt-circle-down"></i> Install App
        </div>
      </Card>
    </Col> -->
    <Col :span="24" v-if="false">
      <Card :padding="10" style="margin:5px 15px;position:relative">
        <div align="center" @click="showInvite = true">
          <Icon type="android-share-alt" size="20" style="vertical-align:middle"></Icon> Invite others to join.
        </div>
      </Card>
    </Col>
    <Col :span="8" v-if="false">
      <Card shadow :padding="10" style="margin:5px 5px 5px 15px;position:relative">
        <router-link tag="p" to="/hotline" align="center" style="display: flex; flex-direction: column">
        <!-- <p align="center"><Icon size="35" type="information-circled"></Icon></p> -->
        <Avatar :src="disaster" shape="square" style="vertical-align: middle;margin-bottom: 10px;"></Avatar>
        <small>Disaster Risk</small></router-link>
      </Card>
    </Col>
    <Col :span="8" v-if="false">
      <Card shadow :padding="10" style="margin:5px 5px 5px;position:relative">
        <router-link tag="p" to="/events" align="center" style="display: flex; flex-direction: column">
        <!-- <p align="center"><Icon size="35" type="android-calendar"></Icon></p> -->
        <Avatar :src="events" shape="square" style="vertical-align: middle;margin-bottom: 10px;"></Avatar>
        <small>Events</small></router-link>
      </Card>
    </Col>
    <Col shadow :span="8" v-if="false">
      <Card shadow :padding="10" style="margin:5px 15px 5px 5px;position:relative">
        <router-link tag="p" :to="'/donate?rid=' + groupID.donate" align="center">
          <p align="center"><Icon size="35" type="heart"></Icon></p>
          <small>Donate</small>
        </router-link>
      </Card>
    </Col>
    <Col :span="24" v-if="false">
      <Card :padding="10" style="margin:5px 15px;position:relative">
        <router-link tag="div" to="/create-organization" align="center">
          <Icon type="ios-people" size="25" style="vertical-align:middle"></Icon> Register your organization
        </router-link>
      </Card>
    </Col>

    <!-- <Col shadow :span="8">
      <Card shadow :padding="10" style="margin:5px 15px 5px 5px;position:relative">
        <div @click="donateShow()" style="text-align:center;">
          <p align="center"><Icon size="35" type="heart"></Icon></p>
          <small>Donate New</small>
        </div>
      </Card>
    </Col>
    <DonateSteps :showDonate="showDonate"></DonateSteps>     -->

    <!-- <ModalHolder class="testShareModal" :title="'Invite others to join'" m-top="0" m-height="100%" :is-show="showInvite">
      <template slot="mheader">
        <b>Invite others to join</b>
      </template>
      <template slot="mcontent">
        <share-component></share-component>
      </template>
      <template slot="mfooter">
          <Button type="text" @click="showInvite = false">Cancel</Button>
      </template>
    </ModalHolder> -->
    <Modal
        class="mCustomModaliOs"
        title="Title"
        :on-cancel="dismiss"
        v-model="showInstruction"
        :mask-closable="false">
        <p slot="header">
          <!-- Install App -->
        </p>
        <p align="center" style="position:relative">
          <Avatar style="left:-50px;position:absolute;width:50px;height:50px;border:1px solid #fbfbfb;background:#fbfbfb" shape="square"></Avatar>&nbsp;
          <Avatar style="width:50px;height:50px;border:1px solid #f2f2f2;background:#fbfbfb" shape="square"></Avatar>&nbsp;
          <Avatar style="width:50px;height:50px;border:1px solid #aaa;" shape="square" :src="applogo"></Avatar>&nbsp;
          <Avatar style="width:50px;height:50px;border:1px solid #f2f2f2;background:#fbfbfb" shape="square" ></Avatar>
          <Avatar style="right:-55px;position:absolute;width:50px;height:50px;border:1px solid #fbfbfb;background:#fbfbfb" shape="square"></Avatar>&nbsp;
        </p>
        <h3 align="center" style="margin-top:10px"><b>Install Sharpen Warrior</b></h3>
        <!-- <p align="center">
          <p align="center" style="margin-top:10px">Install this application on your home screen <br/>for quick and easy access when your're on the go.
        </p> -->
        <p align="center">Just tap <Icon type="ios-upload-outline" style="color:blue" size="20"></Icon>
        then <b>'Add to Home Screen'</b>.<br/>If you don't see this <Icon type="ios-upload-outline" style="color:blue" size="20"></Icon> just swipe down.</p>
        <div slot="footer" style="padding:0">
          <span></span>
          <!-- <p align="center">Just tap <Icon type="ios-upload-outline" style="color:blue" size="20"></Icon>
        then <b>'Add to Home Screen'</b>.<br/>If you don't see this <Icon type="ios-upload-outline" style="color:blue" size="20"></Icon> just swipe down.</p> -->
        </div>
    </Modal>
  </Row>
</template>

<script>
  import {mapGetters} from 'vuex'
  import ModalHolder from "@/components/ModalHolderComponent";
  import DonateSteps from '@/components/DonateStepsComponent';
  import Report from '@/components/ReportComponent';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import logo from '@/assets/logo.png'
  import logoA from '@/assets/tm.png'
  import logocenter from '@/assets/logocenter.png'
  import Utils from '@/utils.js'
  import Ellipsis from '@/ellipsis'
  import VueContentLoading from 'vue-content-loading';
  import VueCookie from 'vue-cookie';
  import _ from 'lodash';

  export default {
    name: "FeaturedFeedComponent",
    components: {
      ModalHolder, DonateSteps, Report, swiper, swiperSlide, Ellipsis, VueContentLoading
    },
    data() {
      return {
        logoA,
        logocenter,
        applogo: logo,
        showInstruction: false,
        presentation: 'slideshow',
        groupID: Cons[0].GROUP_ID,
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 30,
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        Utils
      }
    },
    created() {
      // BroadcastEvent.$on("onInvite",()=> {
      //   // setTimeout(function() {
      //   //   this.showInvite=!this.showInvite;
      //   //   console.log("onInvite...",[this.showInvite]);
      //   // },500);

      //   this.showInvite=!this.showInvite;
      //   console.log("onInvite...",[this.showInvite]);
      // });
    },
    mounted() {
      this.$store.dispatch('feature/getFeaturedActivity');
      this.$store.dispatch('getDynamicUrl', window.location.origin+this.$route.path);
    },
    methods: {
      redirectUrl(){
        window.location.replace(this.getDynamicUrl);
      },
      getTextFromHTML(html) {
        let parsed = new DOMParser().parseFromString(html, "text/html")
        return parsed.children[0].innerText;
      },
      featuredDescription(i) {
        return this.snippet(i)
      },
      naTrigger() {
        console.log("naTrigger...");
      },
      dismiss() {
        this.showInstruction = false;
      },
      donateShow: function() {
        // this.$store.commit('donation/setShowDonate', true);
        this.$store.commit('base/setShowSteps', true);
      },
      snippet(act) {
        switch (act.type) {
          case "attachment":
            switch (act.data.attachment_type) {
              case "video":
                if( act.data.text ) {
                  return act.data.text.replace(/(<([^>]+)>)/ig,"") 
                } else if (act.data.preview_summary) {
                  return act.data.preview_summary.replace(/(<([^>]+)>)/ig,"")
                }
                else {
                  return ''
                }
                break;
              case "link":
                if( act.data.text ) {
                  return act.data.text.replace(/(<([^>]+)>)/ig,"") 
                } else {
                  return act.data.preview_summary.replace(/(<([^>]+)>)/ig,"")
                }
                break;
              default:
                if(act.data.text)
                  return act.data.text.replace(/(<([^>]+)>)/ig,"");
                break;
            }
            break;
          case "trivia":
            if(act.data.question)
              return act.data.question.replace(/(<([^>]+)>)/ig,"");
            break;
          case "reveal":
            if(act.data.question)
            return act.data.question.replace(/(<([^>]+)>)/ig,"");
            break;
          case "recipe":
            if(act.data.description)
              return act.data.description.replace(/(<([^>]+)>)/ig,"");
            break;
          default:
            if(act.data.tip)
              return act.data.tip.replace(/(<([^>]+)>)/ig,"");
            break;
        }
        return '...';
      },
      resendConfirmation() {
        this.$store.dispatch('base/resendEmailConfirmation').then(
          res => {
            this.$Message({
              closable: true,
              durationInSec:3,
              title: { content:'Confirmed' },
              icon: 'checkmark',
              message: { content: 'Confirmation Resend!' },
              buttons: [
                { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
              ]
            });
          }
        );
      },
      postPreviewImage (act) {
        return Utils.getDisplayImage('activity', act, 'medium')
      },
    },
    computed: {
      ...mapGetters(['getDynamicUrl', 'getIsFetchingUrlLoader']),
      checkIsMobile(){
        if(VueCookie.get('os_type') === "ios"){
          return false;
        }else if(window.mobilecheck() && Utils.checkMobileOS() == 'iOS'){
          return true;
        }else{
          return false;
        }
      },
      showArrow: function() {
        if(this.featureActivity.data.length <= 1){
          return 'never'
        }
      },
      showDonate: function() {
        return this.$store.state.donation.showDonate;
      },
      careplan: {
        get () {
          return this.$store.state.resource.singleResource.data
        }
      },
      featureActivity: {
        get () { 
          return this.$store.state.feature.feature;
        }
      },
      isFeatureLoading: {
        get () { return this.$store.state.feature.feature.isLoading }
      },
      invitations: {
        get () { return this.$store.state.user.invitations }
      },
      setViewHasPending: {
        get () {
          let staffInvi = 0, groupInvi = 0
          if (this.invitations.data && 'invites' in this.invitations.data) { staffInvi = this.invitations.data.invites.length }
          if (this.invitations.prescription && 'careplans' in this.invitations.prescription) { groupInvi = this.invitations.prescription.careplans.length }

          return ((staffInvi + groupInvi) > 0)
        }
      },
      userInfo: {
        get () {
          return this.$store.state.user.info
        }
      },
      showSuccess: {
        get() {
          return this.$store.state.share.showSuccess
        }
      },
      closeText: {
        get() {
          return (this.showSuccess) ? 'Close' : 'Cancel'
        }
      },
      events: {
        get() {
          return require('@/assets/events.png')
        }
      },
      disaster: {
        get() {
          return require('@/assets/disaster.png')
        }
      },
      invitation: {
        get() {
          return require('@/assets/invitation.png')
        }
      },
      confirmEmail: {
        get() {
          return require('@/assets/confirm.png')
        }
      },
      tmLogo: {
        get() {
          return require('@/assets/logo.png')
        }
      },
      barIcon: {
        get () {
          return require('@/assets/bars.png')
        }
      },
    }
  }
</script>
